import { PhotoGridBlockProps } from '../../../components/blocks';
import { DirectusImageAsset, mapDirectusImage } from '../general';

// Define the Directus type inline (or add to config/types.ts)
export interface DirectusPhotoGridBlock {
  id?: number;
  image1?: DirectusImageAsset;
  image2?: DirectusImageAsset;
  image3?: DirectusImageAsset;
  caption: string;
}

export const mapDirectusPhotoGridBlock = (block: DirectusPhotoGridBlock): PhotoGridBlockProps => {
  const result = {
    image1: block.image1 ? mapDirectusImage(block.image1) : undefined,
    image2: block.image2 ? mapDirectusImage(block.image2) : undefined,
    image3: block.image3 ? mapDirectusImage(block.image3) : undefined,
    caption: block.caption,
  };
  return result;
};
